import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectService {
  displayText: string;

  private selected = new BehaviorSubject(null);
  currentSelected = this.selected.asObservable();

  setSelect(value: string) {
    this.selected.next(value);
  }

  setDisplay(displayText: string) {
    this.displayText = displayText;
  }
}
